module.exports = __webpack_public_path__ + "img/Weekdays.f716aa2c.svg";